export default {"src":"/_next/static/media/circleInfoDisabled_16.af720902.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};